export default __webpack_public_path__ + "static/media/Lockup.a6aa1d17.svg";